export const LAYOUTS = [
  { id: "hero", name: "Hero", blurb: "Text column left, one large image with a strip of details" },
  { id: "grid", name: "Grid", blurb: "Title band on top, images in an even grid" },
  { id: "editorial", name: "Editorial", blurb: "Full-bleed lead image, notes on a paper card, details stacked right" },
];

export const IMAGE_COUNTS = [1, 2, 3, 4, 5, 6];

// Mirrors backend rooms.room_tiles — boxes as fractions of the slide
export function roomTiles(layout, count) {
  const n = Math.max(1, Math.min(Number(count) || 3, 6));
  const tiles = [];
  if (layout === "grid") {
    const x0 = 0.04, y0 = 0.30, w = 0.92, h = 0.62, gap = 0.012;
    const cols = n <= 3 ? n : 3, rows = n <= 3 ? 1 : 2;
    const tw = (w - gap * (cols - 1)) / cols, th = (h - gap * (rows - 1)) / rows;
    for (let i = 0; i < n; i++) tiles.push({ x: x0 + (i % cols) * (tw + gap), y: y0 + Math.floor(i / cols) * (th + gap), w: tw, h: th });
  } else if (layout === "editorial") {
    if (n === 1) tiles.push({ x: 0, y: 0, w: 1, h: 1 });
    else {
      tiles.push({ x: 0, y: 0, w: 0.72, h: 1 });
      const m = n - 1, gap = 0.012, th = (1 - gap * (m - 1)) / m;
      for (let i = 0; i < m; i++) tiles.push({ x: 0.72 + gap, y: i * (th + gap), w: 0.28 - gap, h: th });
    }
  } else {
    const x0 = 5 / 12, w = 7 / 12;
    if (n === 1) tiles.push({ x: x0, y: 0, w, h: 1 });
    else {
      const gap = 0.012, m = n - 1;
      tiles.push({ x: x0, y: 0, w, h: 0.66 - gap / 2 });
      const tw = (w - gap * (m - 1)) / m;
      for (let i = 0; i < m; i++) tiles.push({ x: x0 + i * (tw + gap), y: 0.66 + gap / 2, w: tw, h: 0.34 - gap / 2 });
    }
  }
  return tiles;
}

export const pct = (t) => ({ left: `${t.x * 100}%`, top: `${t.y * 100}%`, width: `${t.w * 100}%`, height: `${t.h * 100}%` });
